"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useToggle = function (initial) {
    if (initial === void 0) { initial = false; }
    var _a = react_1.useState(initial), isToggled = _a[0], setIsToggled = _a[1];
    var toggle = react_1.useCallback(function (value) {
        setIsToggled(typeof value === "boolean" ? value : !isToggled);
    }, [isToggled]);
    return [isToggled, toggle];
};
